// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voicesBackground {
  background: #1d1a36;
  margin: 8vh 0 8vh 0;
  border-radius: 1.3vw;
}
@media (max-width: 990px) {
  .voicesBackground {
    margin: 0 !important;
  }
}
@media (max-width: 550px) {
  .voicesBackground {
    height: auto !important;
  }
}

.voicesRow {
  margin-top: 10.4vh;
}

.image {
  position: relative;
}

.image__img {
  display: block;
  width: 100%;
}

.image__overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  color: #ffffff;
  font-family: "Quicksand", sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.25s;
}

.image__overlay--blur {
  backdrop-filter: blur(5px);
}

.image__overlay--primary {
  background: linear-gradient(146deg, rgb(255, 182, 160) 0%, rgb(240, 89, 42) 26%, rgb(37, 60, 119) 100%);
  padding: 1vw;
  border-bottom: 6px solid #f0592a;
  border-radius: 1.3vw;
}

.image__overlay > * {
  transform: translateY(20px);
  transition: transform 0.25s;
}

.image__overlay:hover {
  opacity: 1;
}

.image__overlay:hover > * {
  transform: translateY(0);
}

.image__title {
  font-size: 2em;
  font-weight: bold;
}

.image__description {
  font-size: 1.3vw;
  padding: 2.6vw 1.3vw;
  font-family: Helvetica;
  font-weight: 400;
  line-height: 120%;
}
@media (max-width: 990px) {
  .image__description {
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/NucleusteqVoices/nucleusteqVoices.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,mBAAA;EACA,oBAAA;AACF;AACE;EALF;IAMI,oBAAA;EAEF;AACF;AADE;EARF;IASI,uBAAA;EAIF;AACF;;AADA;EACE,kBAAA;AAIF;;AADA;EACE,kBAAA;AAIF;;AADA;EACE,cAAA;EACA,WAAA;AAIF;;AADA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,cAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,yBAAA;AAIF;;AADA;EACE,0BAAA;AAIF;;AADA;EACE,uGAAA;EAIA,YAAA;EACA,gCAAA;EACA,oBAAA;AACF;;AAEA;EACE,2BAAA;EACA,2BAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;AACF;AACE;EAPF;IAQI,eAAA;EAEF;AACF","sourcesContent":[".voicesBackground {\n  background: #1d1a36;\n  margin: 8vh 0 8vh 0;\n  border-radius: 1.3vw;\n\n  @media (max-width:990px){\n    margin: 0 !important;\n  }\n  @media (max-width:550px){\n    height: auto !important;\n  }\n}\n\n.voicesRow {\n  margin-top: 10.4vh;\n}\n\n.image {\n  position: relative;\n}\n\n.image__img {\n  display: block;\n  width: 100%;\n}\n\n.image__overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  color: #ffffff;\n  font-family: \"Quicksand\", sans-serif;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.25s;\n}\n\n.image__overlay--blur {\n  backdrop-filter: blur(5px);\n}\n\n.image__overlay--primary {\n  background: linear-gradient(146deg,\n      rgba(255, 182, 160, 1) 0%,\n      rgba(240, 89, 42, 1) 26%,\n      rgba(37, 60, 119, 1) 100%);\n  padding: 1vw;\n  border-bottom: 6px solid #f0592a;\n  border-radius: 1.3vw;\n}\n\n.image__overlay>* {\n  transform: translateY(20px);\n  transition: transform 0.25s;\n}\n\n.image__overlay:hover {\n  opacity: 1;\n}\n\n.image__overlay:hover>* {\n  transform: translateY(0);\n}\n\n.image__title {\n  font-size: 2em;\n  font-weight: bold;\n}\n\n.image__description {\n  font-size: 1.3vw;\n  padding: 2.6vw 1.3vw;\n  font-family: Helvetica;\n  font-weight: 400;\n  line-height: 120%;\n\n  @media (max-width: 990px) {\n    font-size: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
